import React, { useMemo } from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { HelpButton } from 'components/common/census/HelpButton';
import { useHistory } from 'react-router-dom';
import { BasicCensusFlowLayout } from 'components/common/census/BasicCensusFlowLayout';
import CensusInitiateAddEePageStore, {
  CensusInitiateAddEePageStoreContext,
  useCensusInitiateAddEePageStoreContext,
} from 'store/pages/rfq/census-initiate-add-employees/pageStore';
import useGroupQuoteUrlParams from 'global/hooks/useGroupQuoteUrlParams';
import { NarrowPageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = () => {
  const pageStore = useCensusInitiateAddEePageStoreContext();
  return <BasicCensusFlowLayout pageStore={pageStore} />;
};

const CensusInitiateAddEeUploadPage: React.FC = () => {
  const history = useHistory();
  const { groupId, periodId, cartId } = useGroupQuoteUrlParams();

  function redirectBack(): void {
    history.push(`/initiate-add-employees/${periodId}?cartId=${cartId}&groupId=${groupId}`);
  }

  const pageStore = useMemo(
    () => new CensusInitiateAddEePageStore({ enrollmentPeriodId: periodId, groupId, cartId }),
    [],
  );

  return (
    <CensusInitiateAddEePageStoreContext.Provider value={pageStore}>
      <NarrowPageWrapperStyled>
        <PageHeader title="Census Import" onRedirect={redirectBack} subtitle={<HelpButton />} />
        <PageContent />
      </NarrowPageWrapperStyled>
    </CensusInitiateAddEePageStoreContext.Provider>
  );
};

export default CensusInitiateAddEeUploadPage;
